import { gql } from '@apollo/client';
import { CARD_DATA_FRAGMENT } from '../fragments/graphCardData';

export const IG_PAGE_CARD_QUERY = gql`
  ${CARD_DATA_FRAGMENT}
  query igPageCardQuery(
    $id: String!
    $type: String!
    $dateFrom: String!
    $dateTo: String!
    $compareFrom: String
    $compareTo: String
  ) {
    instagramPage(id: $id) {
      cardData(
        type: $type
        dateFrom: $dateFrom
        dateTo: $dateTo
        compareFrom: $compareFrom
        compareTo: $compareTo
      ) {
        ...CardData
      }
    }
  }
`;
